import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.18506 5L5.19661 0.999998L9.20816 5"
        stroke="#191919"
        strokeLinecap="round"
      />
    </Svg>
  );
};

export default Icon;
